/**
 * @private
 *
 * Key that is defined on the window object to hold the global
 * event emitter to be used by many instances of cog on the same
 * window.
 *
 * @type {string}
 */
export var EVENT_EMITTER_KEY = '__CH_COG_EVENT_EMITTER__';
/**
 * @private
 *
 * Key that is defined on the window object to hold the global
 * Raven SDK instance to be used by many instances of cog on the
 * same window.
 *
 * @type {string}
 */

export var RAVEN_KEY = '__CH_COG_RAVEN__';
/**
 * @private
 *
 * Prefix that should be added to each event in order to ensure they
 * are not colliding with events fired from different modules.
 *
 * @type {string}
 */

export var EVENT_PREFIX = 'ch-cog-';
/**
 * @private
 *
 * Prefix for the key used for saving session tokens to cookies.
 *
 * @type {string}
 */

export var SESSION_COOKIE_KEY_PREFIX = 'chLoginToken-';
/**
 * @private
 *
 * Header that will carry session tokens.
 *
 * TODO: Consider using the Bearer Schema for JSON Web Tokens:
 *
 * Authorization: Bearer <token>
 *
 * See: https://jwt.io/introduction/#how-do-json-web-tokens-work-
 *
 * @type {string}
 */

export var AUTH_HEADER_KEY = 'CH-Login-Token';